import * as CL from '@design-system/component-library';
import { emailMsg, nameMsg, t } from '../../common/i18n/index.js';
import { formatSum } from '../../common/utils/priceUtils.js';
import type { SubscriptionDetailsSoftwareProduct } from '../../generated/api/models.js';

export const getLicensePricePerUnit = (softwareDetails?: SubscriptionDetailsSoftwareProduct) => {
  if (!softwareDetails || !softwareDetails.licencePricePerUnit || !softwareDetails.licencePriceUnit) {
    return undefined;
  }

  return `${formatSum(softwareDetails.licencePricePerUnit, true)} ${softwareDetails.licencePriceUnit.replace(
    /^e\//,
    '€/'
  )}`;
};

export const getAdminUserAccordionContent = (
  softwareProductDetails: SubscriptionDetailsSoftwareProduct,
  adminUserName: string | undefined
) => (
  <CL.Description
    items={[
      {
        title: t.PNS1(nameMsg),
        description: adminUserName,
      },
      {
        title: t.OKYY(emailMsg),
        description: softwareProductDetails.adminUserEmail,
      },
    ]}
  />
);
